import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ukg = defineConnector({
  identifier: "ukg",
  name: "UKG",
  tagLine: "HR and workforce management",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.ukg\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get your UKG API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your UKG instance and navigate to **Administration › System Configuration › API Keys** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your UKG details",
      items: [
        {
          kind: "baseUrl",
          label: "Instance URL",
          required: true,
          placeholder: "https://your-instance.ukg.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your UKG instance.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://service.ultipro.com/authentication/v1/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/v1/commons/persons?limit=1`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    UKG_URL: baseUrl || "",
  }),
});
